import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {MatFormField, MatFormFieldModule} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatIcon} from '@angular/material/icon';
import {AssetFilter} from '../assets/asset-filter';
import {Subscription} from 'rxjs';
import {AssetStateService} from '../assets/asset.state.service';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-search',
    imports: [
        ReactiveFormsModule,
        MatFormField,
        MatInput,
        MatFormFieldModule,
        MatIcon,
        TranslatePipe,
    ],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss'
})
export class SearchComponent implements OnInit, OnDestroy {
  searchForm: FormGroup;
  skuForm: FormGroup;

  assetFilter: AssetFilter | undefined;
  filterSubscription: Subscription |undefined
  constructor(
               private assetStateService: AssetStateService,
               private fb: FormBuilder) {
    this.searchForm = this.fb.group({
      search: ['', []],

    });
    this.skuForm = this.fb.group({
      sku: ['', []]
    })
  }
  ngOnInit() {
    this.filterSubscription = this.assetStateService.filter$.subscribe(filter => {
      this.assetFilter = filter;
    })
  }
  search() {
    if (this.assetFilter) {
      if (this.searchForm.controls['search'].value) {
        this.assetFilter.q = this.searchForm.controls['search'].value;
        this.assetFilter.page = 1;
        this.assetFilter.sku='';
        this.assetStateService.filter = this.assetFilter;
        this.clearValue(null);
      }

    }
  }
  searchForSku() {
    if (this.assetFilter) {
      if(this.skuForm.controls['sku'].value) {
        this.assetFilter.sku = this.skuForm.controls['sku'].value;
        this.assetFilter.page = 1;
        this.assetFilter.q = '';
        this.assetStateService.filter = this.assetFilter;
        this.clearValue(null);
      }
    }

  }
  clearValue(e: any) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.searchForm.reset();
    this.skuForm.reset();
  }
  ngOnDestroy() {
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
  }

}
